import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useLang } from '../../lib/i18n';
import { useAuth } from '../../lib/auth';
import { api } from '../../lib/api';
import { Avatar } from '../../components/Avatar';
import { relativeTime } from '../../lib/shared';
import { I } from '../../components/Icons';
export function TripMembers({ data }) {
    const { T } = useLang();
    const { user } = useAuth();
    const { tripId } = useParams();
    const qc = useQueryClient();
    const iAmHost = data.members.find((m) => m.id === user?.id)?.role === 'host';
    const remove = useMutation({
        mutationFn: (id) => api.del(`/trips/${tripId}/members/${id}`),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['sync', tripId] }),
    });
    return (_jsx("div", { className: "tt-card", children: data.members.map((m) => (_jsxs("div", { style: {
                display: 'grid', gridTemplateColumns: '48px 1fr auto auto',
                gap: 14, alignItems: 'center',
                padding: '14px 16px', borderBottom: '1px solid var(--ink-100)',
            }, children: [_jsx(Avatar, { name: m.name, bg: m.avatar_color, size: 44 }), _jsxs("div", { children: [_jsx("div", { style: { fontSize: 15, fontWeight: 500 }, children: m.name }), _jsxs("div", { className: "tt-meta", style: { textTransform: 'none', letterSpacing: 0 }, children: [m.email, " \u00B7 ", T('加入於', '加入于'), " ", relativeTime(m.joined_at)] })] }), _jsx("span", { className: `tt-chip ${m.role === 'host' ? 'sun' : 'gray'}`, children: m.role === 'host' ? T('主辦', '主办') : T('成員', '成员') }), iAmHost && m.id !== user?.id ? (_jsx("button", { className: "tt-btn ghost sm", style: { color: 'var(--bad)' }, onClick: () => confirm(T('確定移除這位成員？', '确定移除这位成员？')) && remove.mutate(m.id), children: _jsx(I.trash, {}) })) : _jsx("span", {})] }, m.id))) }));
}
